/**
 * Minimal class joiner. Deliberately not `tailwind-merge` — the components here
 * put the incoming `className` last so callers can override, which covers every
 * case in this suite without shipping a conflict resolver.
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
